<template>
  <section class="premiacoes-wrapper py-16">
    <div class="bg-pattern"></div>
    
    <v-container class="position-relative z-index-2">
      <div class="text-center mb-16">
        <h2 class="text-overline red--text font-weight-bold mb-2 tracking-widest">
          RECONHECIMENTO
        </h2>
        <h1 class="text-h4 text-md-h3 font-weight-black white--text text-uppercase mb-6">
          Nossas Premiações
        </h1>
        <div class="mx-auto gradient-line"></div>
      </div>

      <div v-if="loading" class="text-center py-10">
        <v-progress-circular indeterminate color="#D32F2F" size="60"></v-progress-circular>
      </div>

      <v-row v-else justify="center">
        <v-col 
          v-for="premio in premiacoes" 
          :key="premio.id" 
          cols="12" 
          md="6" 
          lg="4"
        >
          <v-card 
            class="fill-height rounded-xl overflow-hidden card-premio"
            color="#1a1a1a"
            dark
            elevation="10"
          >
            <div class="carousel-wrapper">
              <v-carousel 
                v-if="premio.fotos && premio.fotos.length" 
                height="260" 
                hide-delimiters 
                :show-arrows="premio.fotos.length > 1"
                cycle
                interval="5000"
              >
                <v-carousel-item 
                  v-for="(foto, i) in premio.fotos" 
                  :key="i" 
                  :src="foto" 
                  cover
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-carousel-item>
              </v-carousel>
              
              <v-sheet 
                v-else 
                color="grey darken-4" 
                height="260" 
                class="d-flex align-center justify-center"
              >
                <v-icon size="64" color="grey darken-2">mdi-trophy-variant-outline</v-icon>
              </v-sheet>

              <div class="icon-badge elevation-6">
                <v-icon color="white">mdi-star</v-icon>
              </div>
            </div>
            
            <div class="pa-6 pt-8">
              <h3 class="text-h5 white--text font-weight-bold mb-3 text-uppercase line-clamp-2">
                {{ premio.titulo }}
              </h3>
              
              <v-divider class="red darken-4 mb-4" style="width: 40px; border-width: 2px;"></v-divider>
              
              <p class="grey--text text--lighten-1 body-1 mb-0 text-justify" style="line-height: 1.6;">
                {{ premio.descricao }}
              </p>
            </div>
          </v-card>
        </v-col>

        <v-col v-if="!premiacoes.length" cols="12" class="text-center grey--text">
          <v-icon size="64" color="grey darken-3" class="mb-4">mdi-trophy-broken</v-icon>
          <p>Nenhuma premiação registrada no momento.</p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import PremiacoesService from '@/services/premiacoes.service';

export default {
  name: "PremiacoesSection",
  data: () => ({ 
    premiacoes: [],
    loading: true 
  }),
  async mounted() {
    try {
      this.premiacoes = await PremiacoesService.getAll();
    } catch (error) {
      console.error("Erro ao carregar premiações:", error);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.premiacoes-wrapper {
  background-color: #0F0F0F;
  position: relative;
  border-top: 1px solid #1a1a1a;
}

.gradient-line {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #D32F2F 0%, #ff7961 100%);
  border-radius: 4px;
}

.tracking-widest {
  letter-spacing: 3px !important;
}

.bg-pattern {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  opacity: 0.03;
  background-image: radial-gradient(#ffffff 1px, transparent 1px);
  background-size: 30px 30px;
  pointer-events: none;
}

.z-index-2 {
  position: relative;
  z-index: 2;
}

/* Card Styling */
.card-premio {
  border: 1px solid rgba(255,255,255,0.05) !important;
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), box-shadow 0.3s ease;
}

.card-premio:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(211, 47, 47, 0.15) !important;
  border-color: #D32F2F !important;
}

.carousel-wrapper {
  position: relative;
}

.icon-badge {
  position: absolute;
  bottom: -20px;
  right: 20px;
  background: linear-gradient(135deg, #D32F2F 0%, #B71C1C 100%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>